module.exports = __webpack_public_path__ + "static/media/password.3639d44a.svg";